import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { CurrentCouponsComponent } from '../current-coupons/current-coupons.component';


declare const $ : any;

@Component({
  selector: 'app-user-coupons-modal',
  templateUrl: './user-coupons-modal.component.html',
  styleUrls: ['./user-coupons-modal.component.css']
})

export class UserCouponsModalComponent implements OnInit {

  @Output() notifyParent: EventEmitter<any> = new EventEmitter();
  @ViewChild(CurrentCouponsComponent) currentCouponsComponent: CurrentCouponsComponent; 

  
  constructor() { }

  ngOnInit() {}

  show(){
    this.currentCouponsComponent.refresh();
    $('#app-user-coupons-modal').modal('show');
  }

  getNotification(event:any){
    this.notifyParent.emit();
  }

  close(){
    this.notifyParent.emit();
  }


}
